{
    "Routes-Quick-Search-Fields": [
      {
          "label": "Event Type", "columnname": "EventType", "placeholder": "Event Type",
          "width": "", "datatype": "String", "isLarge": false
      },
      {
          "label": "Symbol", "columnname": "Symbol", "placeholder": "Symbol",
          "width": "", "datatype": "String", "isLarge": false
      },
      {
          "label": "OMS Order ID", "columnname": "OMSOrderID", "placeholder": "OMS Order ID",
          "width": "", "datatype": "String", "isLarge": true
      },
      {
          "label": "Route Id", "columnname": "RouteId", "placeholder": "Route Id",
          "width": "", "datatype": "String", "isLarge": true
      },
      {
          "label": "Ext Destination", "columnname": "ExtDestination", "placeholder": "Ext Destination",
          "width": "", "datatype": "String", "isLarge": false
      },
      {
          "label": "OMSSystem", "columnname": "OMSSystem", "placeholder": "OMSSystem",
          "width": "", "datatype": "String", "isLarge": false
      }
    ],
    "Routes-Grid-Columns": [
      {
        "display": "true",
        "ui_columnname": "Event type",
        "db_columnname": "EventType",
        "datatype": "String",
        "mappingkey": "eventType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Route Date Time",
        "db_columnname": "RouteDateTime",
        "datatype": "String",
        "mappingkey": "routeDateTime",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "System Date Time",
        "db_columnname": "SystemDateTime",
        "datatype": "DateTime",
        "mappingkey": "systemDateTime",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "OrderDateTime",
        "db_columnname": "orderDateTime",
        "datatype": "String",
        "mappingkey": "orderDateTime",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "OMS Order ID",
        "db_columnname": "OMSOrderID",
        "datatype": "String",
        "mappingkey": "oMSOrderId",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Order ID",
        "db_columnname": "OrderID",
        "datatype": "String",
        "mappingkey": "orderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Route ID",
        "db_columnname": "RouteId",
        "datatype": "String",
        "mappingkey": "routeId",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Symbol",
        "db_columnname": "Symbol",
        "datatype": "String",
        "mappingkey": "symbol",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Side",
        "db_columnname": "BuySellCode",
        "datatype": "String",
        "mappingkey": "buySellCode",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Route Qty",
        "db_columnname": "Quantity",
        "datatype": "float",
        "mappingkey": "quantity",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "MinQuantity",
        "db_columnname": "MinQuantity",
        "datatype": "float",
        "mappingkey": "minQuantity",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Route Price",
        "db_columnname": "LimitPrice",
        "datatype": "float",
        "mappingkey": "limitPrice",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Price Type",
        "db_columnname": "PriceType",
        "datatype": "String",
        "mappingkey": "priceType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Ext Destination",
        "db_columnname": "ExtDestination",
        "datatype": "String",
        "mappingkey": "extDestination",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Cancel Route ID",
        "db_columnname": "CancelRouteId",
        "datatype": "String",
        "mappingkey": "cancelRouteId",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Reject Reason",
        "db_columnname": "RejectReason",
        "datatype": "String",
        "mappingkey": "rejectReason",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "TIF",
        "db_columnname": "TimeInForce",
        "datatype": "String",
        "mappingkey": "timeInForce",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Not Held",
        "db_columnname": "NotHeld",
        "datatype": "String",
        "mappingkey": "notHeld",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Spl Handling Code",
        "db_columnname": "SplHandlingCode",
        "datatype": "String",
        "mappingkey": "splHandlingCode",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "DNR/DNI",
        "db_columnname": "DoNotReduceIncrease",
        "datatype": "String",
        "mappingkey": "doNotReduceIncrease",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "AON",
        "db_columnname": "AllOrNone",
        "datatype": "String",
        "mappingkey": "allOrNone",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "TradingSessionCode",
        "db_columnname": "tradingSessionCode",
        "datatype": "String",
        "mappingkey": "tradingSessionCode",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "ISO",
        "db_columnname": "ISO",
        "datatype": "String",
        "mappingkey": "iSO",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Affiliate Flag",
        "db_columnname": "affiliateFlag",
        "datatype": "String",
        "mappingkey": "affiliateFlag",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Bid Price",
        "db_columnname": "BidPrice",
        "datatype": "float",
        "mappingkey": "bidPrice",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Ask Price",
        "db_columnname": "AskPrice",
        "datatype": "Float",
        "mappingkey": "askPrice",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Stop Price",
        "db_columnname": "StopPrice",
        "datatype": "float",
        "mappingkey": "stopPrice",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Expiry Date",
        "db_columnname": "ExpiryDate",
        "mappingkey": "expiryDate",
        "datatype": "Date",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Expiry Time",
        "db_columnname": "ExpiryTime",
        "datatype": "String",
        "mappingkey": "expiryTime",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Limit Order display",
        "db_columnname": "LimitOrderdisplay",
        "datatype": "String",
        "mappingkey": "limitOrderDisplay",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Program Trading",
        "db_columnname": "ProgramTrading",
        "datatype": "String",
        "mappingkey": "programTrading",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Cancel By Cust",
        "db_columnname": "CancelByCust",
        "datatype": "String",
        "mappingkey": "cancelByCust",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Order Desk",
        "db_columnname": "OrderDesk",
        "datatype": "String",
        "mappingkey": "orderDesk",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Destination Desk",
        "db_columnname": "DestinationDesk",
        "datatype": "String",
        "mappingkey": "destinationDesk",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Originating Desk",
        "db_columnname": "OriginatingDesk",
        "datatype": "String",
        "mappingkey": "originatingDesk",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Instrument Type",
        "db_columnname": "instrumentType",
        "datatype": "String",
        "mappingkey": "instrumentType",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Barrier Id",
        "db_columnname": "barrierID",
        "datatype": "String",
        "mappingkey": "barrierID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Receive Method",
        "db_columnname": "ReceiveMethod",
        "datatype": "String",
        "mappingkey": "receiveMethod",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Exchange ID",
        "db_columnname": "ExchangeId",
        "datatype": "String",
        "mappingkey": "exchangeId",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "RootOrderID",
        "db_columnname": "rootOrderID",
        "datatype": "String",
        "mappingkey": "rootOrderID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "CancelQuantity",
        "db_columnname": "cancelQuantity",
        "datatype": "Float",
        "mappingkey": "cancelQuantity",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "LeavesQty",
        "db_columnname": "leavesQuantity",
        "datatype": "float",
        "mappingkey": "leavesQuantity",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Position",
        "db_columnname": "Position",
        "datatype": "Int",
        "mappingkey": "position",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "display Qty",
        "db_columnname": "displayQty",
        "datatype": "float",
        "mappingkey": "displayQty",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Trader Account",
        "db_columnname": "TraderAccount",
        "datatype": "String",
        "mappingkey": "traderAccount",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "ISO ID",
        "db_columnname": "ISOID",
        "datatype": "String",
        "mappingkey": "iSOID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Capacity",
        "db_columnname": "Capacity",
        "datatype": "String",
        "mappingkey": "capacity",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "IOC",
        "db_columnname": "IOC",
        "datatype": "String",
        "mappingkey": "iOC",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Locate Info",
        "db_columnname": "LocateInfo",
        "datatype": "String",
        "mappingkey": "locateInfo",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Delivery Instructions",
        "db_columnname": "DeliveryInstructions",
        "datatype": "String",
        "mappingkey": "deliveryInstructions",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Strategy",
        "db_columnname": "Strategy",
        "datatype": "String",
        "mappingkey": "strategy",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Strategy Details",
        "db_columnname": "StrategyDetails",
        "datatype": "String",
        "mappingkey": "strategyDetails",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Route Method",
        "db_columnname": "RouteMethod",
        "datatype": "String",
        "mappingkey": "routeMethod",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Directed Destination",
        "db_columnname": "DirectedDestination",
        "datatype": "Int",
        "mappingkey": "directedDestination",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Branch Seq Num",
        "db_columnname": "BranchSeqNum",
        "datatype": "String",
        "mappingkey": "branchSeqNum",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Version Num",
        "db_columnname": "VersionNum",
        "datatype": "Int",
        "mappingkey": "versionNum",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Arbitrage",
        "db_columnname": "Arbitrage",
        "datatype": "String",
        "mappingkey": "arbitrage",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Terminal User",
        "db_columnname": "TerminalUser",
        "datatype": "String",
        "mappingkey": "terminalUser",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Bid Size",
        "db_columnname": "BidSize",
        "datatype": "Int",
        "mappingkey": "bidSize",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Ask Size",
        "db_columnname": "AskSize",
        "datatype": "Int",
        "mappingkey": "askSize",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Info1",
        "db_columnname": "info1",
        "datatype": "String",
        "mappingkey": "info1",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Info2",
        "db_columnname": "info2",
        "datatype": "String",
        "mappingkey": "info2",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Terminal User",
        "db_columnname": "terminalUser",
        "datatype": "String",
        "mappingkey": "terminalUser",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Connection ID",
        "db_columnname": "connectionID",
        "datatype": "String",
        "mappingkey": "connectionID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Order Version Num",
        "db_columnname": "orderVersionNum",
        "datatype": "String",
        "mappingkey": "orderVersionNum",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "ReasonText",
        "db_columnname": "reasonText",
        "datatype": "String",
        "mappingkey": "reasonText",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "IgnoreWarningsID",
        "db_columnname": "ignoreWarningsID",
        "datatype": "String",
        "mappingkey": "ignoreWarningsID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "IgnoreWarningsName",
        "db_columnname": "ignoreWarningsName",
        "datatype": "String",
        "mappingkey": "ignoreWarningsName",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Auditor",
        "db_columnname": "auditor",
        "datatype": "String",
        "mappingkey": "auditor",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "MultiLegInd",
        "db_columnname": "multiLegInd",
        "datatype": "String",
        "mappingkey": "multiLegInd",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "PairedOrderID",
        "db_columnname": "pairedOrderID",
        "datatype": "String",
        "mappingkey": "pairedOrderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "InfoBarrierID",
        "db_columnname": "infoBarrierID",
        "datatype": "String",
        "mappingkey": "infoBarrierID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "NetPrice",
        "db_columnname": "netPrice",
        "datatype": "Int",
        "mappingkey": "netPrice",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "QuoteKeyDate",
        "db_columnname": "quoteKeyDate",
        "datatype": "String",
        "mappingkey": "quoteKeyDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "QuoteID",
        "db_columnname": "quoteID",
        "datatype": "String",
        "mappingkey": "quoteID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "UnderlyingSymbol",
        "db_columnname": "underlyingSymbol",
        "datatype": "String",
        "mappingkey": "underlyingSymbol",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "LegNum",
        "db_columnname": "legNum",
        "datatype": "Int",
        "mappingkey": "legNum",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "TotalLeg",
        "db_columnname": "totalLeg",
        "datatype": "Int",
        "mappingkey": "totalLeg",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "LegRatioQuantity",
        "db_columnname": "legRatioQuantity",
        "datatype": "Float",
        "mappingkey": "legRatioQuantity",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
           {
        "display": "true",
        "ui_columnname": "SeqNum",
        "db_columnname": "LocateInfo",
        "datatype": "String",
        "mappingkey": "locateInfo",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "OMSSystem",
        "db_columnname": "OMSSystem",
        "datatype": "String",
        "mappingkey": "oMSSystem",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "File ID",
        "db_columnname": "ClientDataHeaderID",
        "datatype": "int",
        "mappingkey": "clientDataHeaderID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Created Date",
        "db_columnname": "createdDate",
        "datatype": "String",
        "mappingkey": "createdDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "Updated Date",
        "db_columnname": "updatedDate",
        "datatype": "String",
        "mappingkey": "updatedDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "true",
        "ui_columnname": "User",
        "db_columnname": "user",
        "datatype": "String",
        "mappingkey": "user",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "false",
        "ui_columnname": "CATReporterIMID",
        "db_columnname": "FirmMPID",
        "datatype": "String",
        "mappingkey": "firmMPID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "false",
        "ui_columnname": "DupRouteIDCond",
        "db_columnname": "DupRouteIDCond",
        "datatype": "float",
        "mappingkey": "dupRouteIDCond",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "false",
        "ui_columnname": "LegID",
        "db_columnname": "LegID",
        "datatype": "String",
        "mappingkey": "legID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "false",
        "ui_columnname": "OpenCloseIndicator",
        "db_columnname": "OpenCloseInd",
        "datatype": "String",
        "mappingkey": "openCloseInd",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "false",
        "ui_columnname": "NextUnLinkInd",
        "db_columnname": "NextUnLinkInd",
        "datatype": "String",
        "mappingkey": "nextUnLinkInd",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "false",
        "ui_columnname": "PriorUnlinked",
        "db_columnname": "UnLinkInd",
        "datatype": "String",
        "mappingkey": "unLinkInd",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      },
      {
        "display": "false",
        "ui_columnname": "ExchOriginCode",
        "db_columnname": "ExchOriginCode",
        "datatype": "String",
        "mappingkey": "exchOriginCode",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
      }
    ],
    "Routes-Opted-Export-CSV-Grid-Columns": [
      {
        "columnName": "CATReporterIMID",
        "dbFieldValue": "FirmMPID"
      },
      {
        "columnName": "SystemGroup",
        "dbFieldValue": "OMSSystem"
      },
      {
        "columnName": "Type",
        "dbFieldValue": "EventType"
      },
      {
        "columnName": "RoutedOrderID",
        "dbFieldValue": "RouteId"
      },
      {
        "columnName": "OrderID",
        "dbFieldValue": "OrderID"
      },
      {
        "columnName": "ElectronicTimestamp",
        "dbFieldValue": "SystemDateTime"
      },
      {
        "columnName": "EventTimestamp",
        "dbFieldValue": "RouteDateTime"
      },
      {
        "columnName": "Symbol",
        "dbFieldValue": "Symbol"
      },
      {
        "columnName": "Side",
        "dbFieldValue": "BuySellCode"
      },
      {
        "columnName": "Quantity",
        "dbFieldValue": "Quantity"
      },
      {
        "columnName": "MinQty",
        "dbFieldValue": "MinQuantity"
      },
      {
        "columnName": "DupRouteIDCond",
        "dbFieldValue": "DupRouteIDCond"
      },
      {
        "columnName": "OrderType",
        "dbFieldValue": "PriceType"
      },
      {
        "columnName": "Price",
        "dbFieldValue": "LimitPrice"
      },
      {
        "columnName": "StopPrice",
        "dbFieldValue": "StopPrice"
      },
      {
        "columnName": "TimeInForce",
        "dbFieldValue": "TimeInForce"
      },
      {
        "columnName": "ExpiryDate",
        "dbFieldValue": "ExpiryDate"
      },
      {
        "columnName": "ExpiryTime",
        "dbFieldValue": "ExpiryTime"
      },
      {
        "columnName": "Destination",
        "dbFieldValue": "ExtDestination"
      },
      {
        "columnName": "Initiator",
        "dbFieldValue": "CancelByCust"
      },
      {
        "columnName": "PriorRoutedOrderID",
        "dbFieldValue": "CancelRouteId"
      },
      {
        "columnName": "HandlingInstructions",
        "dbFieldValue": "SplHandlingCode"
      },
      {
        "columnName": "CustDspIntrFlag",
        "dbFieldValue": "LimitOrderdisplay"
      },
      {
        "columnName": "RouteRejectedFlag",
        "dbFieldValue": "RejectReason"
      },
      {
        "columnName": "ManualFlag",
        "dbFieldValue": "RouteMethod"
      },
      {
        "columnName": "IsoInd",
        "dbFieldValue": "ISO"
      },
      {
        "columnName": "OrderKeyDate",
        "dbFieldValue": "OrderDateTime"
      },
      {
        "columnName": "TradingSession",
        "dbFieldValue": "tradingSessionCode"
      },
      {
        "columnName": "SessionID",
        "dbFieldValue": "ConnectionID"
      },
      {
        "columnName": "LegID",
        "dbFieldValue": "LegID"
      },
      {
        "columnName": "InstrumentType",
        "dbFieldValue": "instrumentType"
      },
      {
        "columnName": "openCloseIndicator",
        "dbFieldValue": "OpenCloseInd"
      },
      {
        "columnName": "PriorUnlinked",
        "dbFieldValue": "UnLinkInd"
      },
      {
        "columnName": "ExchOriginCode",
        "dbFieldValue": "ExchOriginCode"
      },
      {
        "columnName": "NextUnLinkInd",
        "dbFieldValue": "NextUnLinkInd"
      },
      {
        "columnName": "AffiliateFlag",
        "dbFieldValue": "AffiliateFlag"
      },
      {
        "columnName": "LeavesQty",
        "dbFieldValue": "LeavesQuantity"
      },
      {
        "columnName": "MultiLegInd",
        "dbFieldValue": "MultiLegInd"
      },
      {
        "columnName": "PairedOrderID",
        "dbFieldValue": "PairedOrderID"
      },
      {
        "columnName": "InfoBarrierID",
        "dbFieldValue": "InfoBarrierID"
      },
      {
        "columnName": "NetPrice",
        "dbFieldValue": "NetPrice"
      },
      {
        "columnName": "QuoteKeyDate",
        "dbFieldValue": "QuoteKeyDate"
      },
      {
        "columnName": "QuoteID",
        "dbFieldValue": "QuoteID"
      },
      {
        "columnName": "CancelQty",
        "dbFieldValue": "CancelQuantity"
      },
      {
        "columnName": "Underlying",
        "dbFieldValue": "UnderlyingSymbol"
      },
      {
        "columnName": "LegNum",
        "dbFieldValue": "LegNum"
      },
      {
        "columnName": "NumberOfLegs",
        "dbFieldValue": "totalLeg"
      },
      {
        "columnName": "LegRatioQuantity",
        "dbFieldValue": "LegRatioQuantity"
      },
      {
        "columnName": "SeqNum",
        "dbFieldValue": "LocateInfo"
      }
    ]
}